import anime from 'animejs/lib/anime.es.js';

export const AnimatedLines = (function () {
	'use strict';

    let $animated_lines,
				$three_up,
				$radial,
				$zigzag,
				$bounce_up,
				start_delay;

	function init() {
		$animated_lines = $('.animated-lines');
		$three_up = $('.animated-lines--three-up');
		$radial = $('.animated-lines--radial');
		$zigzag = $('.animated-lines--zig-zag');
		$bounce_up = $('.animated-lines--bounce-up');
		start_delay = 750;

		// delay animation start a bit
		events();
	}

	function events() {

		$animated_lines.each( function(){
			var $t = $(this);

			const observer = new IntersectionObserver(
				entries => {
					entries.forEach(entry => {
						if (entry.intersectionRatio >= 0.7) {
							runAnimation($t);
							observer.disconnect();
						}
					})
				},
				{
					threshold: 0.7
				});

			observer.observe($t[0]);
		});
	}

  function runAnimation($t) {
		$t.addClass('loaded');


		// THREE UP
		if ($t.hasClass('animated-lines--three-up')) {

			let path1 = anime.path('.animated-lines--three-up line.path-1'),
					path2 = anime.path('.animated-lines--three-up line.path-2'),
					path3 = anime.path('.animated-lines--three-up line.path-3');

			// lines
			anime({
				targets: '.animated-lines--three-up line',
				strokeDashoffset: [anime.setDashoffset, 0],
				easing: 'easeInOutSine',
				duration: 800,
				delay: function(el, i) { return (i * 300) + start_delay },
			});

			// dots
			let threeup_tl = anime.timeline({
			  easing: 'easeOutExpo',
			  duration: 800,
				delay: start_delay
			});

			threeup_tl
			.add({
				targets: '.animated-lines--three-up .dot-1',
			  translateX: path1('x'),
			  translateY: path1('y'),
				rotate: path1('angle'),
			  easing: 'easeInOutSine',
			})
			.add({
				targets: '.animated-lines--three-up .dot-2',
			  opacity: 1,
			  easing: 'easeInOutSine',
				duration: 300,
			}, '-=1200')
			.add({
				targets: '.animated-lines--three-up .dot-2',
			  translateX: path2('x'),
			  translateY: path2('y'),
			  rotate: path2('angle'),
			  easing: 'easeInOutSine',
			}, 300)
			.add({
				targets: '.animated-lines--three-up .dot-3',
			  opacity: 1,
			  easing: 'easeInOutSine',
				duration: 300,
			}, '-=1200')
			.add({
				targets: '.animated-lines--three-up .dot-3',
			  translateX: path3('x'),
			  translateY: path3('y'),
			  rotate: path3('angle'),
			  easing: 'easeInOutSine',
			}, 600);

		}


		// RADIAL
		if ($t.hasClass('animated-lines--radial')) {
			anime({
			  targets: '.animated-lines--radial line',
			  strokeDashoffset: [anime.setDashoffset, 0],
			  easing: 'easeInOutSine',
			  duration: 1200,
				delay: start_delay
			});

			anime({
				targets: '.animated-lines--radial .center-dot',
				opacity: 1,
				easing: 'easeInOutSine',
				duration: 800,
				delay: start_delay
			});
		}


		// ZIG ZAG
		if ($t.hasClass('animated-lines--zig-zag')) {

			let path = anime.path('.animated-lines--zig-zag polyline');

			anime({
			  targets: '.animated-lines--zig-zag polyline',
			  strokeDashoffset: [anime.setDashoffset, 0],
			  easing: 'easeInOutSine',
			  duration: 1600,
				delay: start_delay
			});

			anime({
				targets: '.animated-lines--zig-zag .dot',
				translateX: path('x'),
				translateY: path('y'),
				// rotate: path('angle'),
				easing: 'easeInOutSine',
				duration: 1600,
				delay: start_delay
			});
		}


		// BOUNCE UP
		if ($t.hasClass('animated-lines--bounce-up')) {

			let path = anime.path('.animated-lines--bounce-up polyline');

			anime({
			  targets: '.animated-lines--bounce-up polyline',
			  strokeDashoffset: [anime.setDashoffset, 0],
			  easing: 'easeInOutSine',
			  duration: 1600,
				delay: start_delay / 2
			});

			anime({
				targets: '.animated-lines--bounce-up .dot',
				translateX: path('x'),
				translateY: path('y'),
				// rotate: path('angle'),
				easing: 'easeInOutSine',
				duration: 1600,
				delay: start_delay / 2
			});
		}


		// TIMELINE
		if ($t.hasClass('animated-lines--timeline')) {

			let path1 = anime.path('.animated-lines--timeline line.path-1'),
						path2 = anime.path('.animated-lines--timeline line.path-2'),
						path3 = anime.path('.animated-lines--timeline line.path-3');

			// lines
			anime({
				targets: '.animated-lines--timeline line',
				strokeDashoffset: [anime.setDashoffset, 0],
				easing: 'easeInOutSine',
				duration: 800,
				delay: function(el, i) { return (i * 400) + start_delay + 100 },
			});

			anime({
				targets: '.animated-lines--timeline line',
				easing: 'easeInOutSine',
				opacity: 1,
				duration: 100,
				delay: function(el, i) { return (i * 400) + start_delay + 100 },
			});


			// dots
			let dots_tl = anime.timeline({
				easing: 'easeOutExpo',
				duration: 150,
				delay: start_delay
			});

			dots_tl
			.add({
				targets: '.animated-lines--timeline .dot-1',
				opacity: 1,
				easing: 'easeInOutSine',
			}, 0)
			.add({
				targets: '.animated-lines--timeline .dot-1',
				translateX: path1('x'),
				translateY: path1('y'),
				easing: 'easeInOutSine',
				duration: 800,
			}, 50)
			.add({
				targets: '.animated-lines--timeline .dot-2',
				opacity: 1,
				easing: 'easeInOutSine',
			}, 400)
			.add({
				targets: '.animated-lines--timeline .dot-2',
				translateX: path2('x'),
				translateY: path2('y'),
				easing: 'easeInOutSine',
				duration: 800,
			}, 450)
			.add({
				targets: '.animated-lines--timeline .dot-3',
				opacity: 1,
				easing: 'easeInOutSine',
			}, 800)
			.add({
				targets: '.animated-lines--timeline .dot-3',
				translateX: path3('x'),
				translateY: path3('y'),
				easing: 'easeInOutSine',
				duration: 800,
			}, 850);

		} // timeline


		// Border
		if ($t.hasClass('animated-lines--border')) {

			let path = anime.path('.animated-lines--border .path');

			anime({
			  targets: '.animated-lines--border .path',
			  strokeDashoffset: [anime.setDashoffset, 0],
			  easing: 'easeInOutSine',
			  duration: 1800,
				delay: start_delay
			});

			anime({
				targets: '.animated-lines--border .dot',
				translateX: path('x'),
				translateY: path('y'),
				// rotate: path('angle'),
				easing: 'easeInOutSine',
				duration: 1800,
				delay: start_delay
			});
		} // border


		// Circles
		if ($t.hasClass('animated-lines--circles')) {

			let path1 = anime.path('.animated-lines--circles .path-1'),
					path2 = anime.path('.animated-lines--circles .path-2'),
					path3 = anime.path('.animated-lines--circles .path-3'),
					path4 = anime.path('.animated-lines--circles .path-4');

			// anime({
			// 	targets: '.animated-lines--circles .path-1',
			// 	strokeDashoffset: [anime.setDashoffset, 0],
			// 	easing: 'easeInOutSine',
			// 	duration: 1800,
			// 	delay: start_delay
			// });

			let circles_tl = anime.timeline({
				easing: 'easeOutExpo',
				duration: 1000,
				delay: start_delay + 100
			});

			circles_tl
			.add({
				targets: '.animated-lines--circles .path-1',
				easing: 'easeInOutSine',
				strokeDashoffset: [anime.setDashoffset, 0],
			})
			.add({
				targets: '.animated-lines--circles .path-2',
				easing: 'easeInOutSine',
				strokeDashoffset: [anime.setDashoffset, 0],
			}, '-=900')
			.add({
				targets: '.animated-lines--circles .path-3',
				easing: 'easeInOutSine',
				strokeDashoffset: [anime.setDashoffset, 0],
			}, '-=900')
			.add({
				targets: '.animated-lines--circles .path-4',
				easing: 'easeInOutSine',
				strokeDashoffset: [anime.setDashoffset, 0],
			}, '-=900');


			let dots_tl2 = anime.timeline({
				easing: 'easeOutExpo',
				duration: 1000,
				delay: start_delay
			});

			dots_tl2
			.add({
				targets: '.animated-lines--circles .dot-1',
				opacity: 1,
				easing: 'easeInOutSine',
			}, 0)
			.add({
				targets: '.animated-lines--circles .dot-1',
				translateX: path1('x'),
				translateY: path1('y'),
				easing: 'easeInOutSine',
			}, 50)

			.add({
				targets: '.animated-lines--circles .dot-2',
				opacity: 1,
				easing: 'easeInOutSine',
				duration: 200,
			}, 900)
			.add({
				targets: '.animated-lines--circles .dot-2',
				translateX: path2('x'),
				translateY: path2('y'),
				easing: 'easeInOutSine',
			}, 1000)


			.add({
				targets: '.animated-lines--circles .dot-3',
				opacity: 1,
				easing: 'easeInOutSine',
				duration: 200,
			}, 1900)
			.add({
				targets: '.animated-lines--circles .dot-3',
				translateX: path3('x'),
				translateY: path3('y'),
				easing: 'easeInOutSine',
			}, 2000)


			.add({
				targets: '.animated-lines--circles .dot-4',
				opacity: 1,
				easing: 'easeInOutSine',
				duration: 200,
			}, 2800)
			.add({
				targets: '.animated-lines--circles .dot-4',
				translateX: path4('x'),
				translateY: path4('y'),
				easing: 'easeInOutSine',
			}, 2900)

		} // circles

  }

	return {
		init: init,
	};
})();
